// extracted by mini-css-extract-plugin
module.exports = {"dropzone":"AttachmentAddZone_dropzone__LIs5V","wrapper":"AttachmentAddZone_wrapper__2TcKQ"};